import React from 'react';
import { Text } from '@cashfree-intl/coherent';
import { DATA_MAPPER } from './constants';

export const toggleStateText = (toggleState: boolean) =>
  toggleState ? (
    <Text color="success" variant="b12">
      Active
    </Text>
  ) : (
    <Text variant="b12" color="bodyLight">
      Activate
    </Text>
  );

export function getModifiedTransactionsData(responseData: Array<any>) {
  const mapper = DATA_MAPPER;
  let responseArr = [];

  for (let i = 0; i < responseData.length; i += 1) {
    const obj = responseData[i];
    const responseObj = {
      addedOn: obj?.addedOn,
      event: obj?.event,
      eventId: obj?.eventId,
      utr:obj?.utr,
      saleType: obj?.saleType,
      amount: obj?.amount,
      closingBalance: obj?.closingBalance,
    };
    Object.keys(obj).forEach(item => {
      if (mapper[item]) {
        responseObj[item] = obj[item];
      }
    });
    responseArr = [...responseArr, responseObj];
  }
  return responseArr;
}

export function getHeaderForTransactionsData(responseData: Array<any>) {
  const responseArr = Object.keys(responseData[0]);
  const mapper = DATA_MAPPER;
  let headerArr = [];
  responseArr.forEach(item => {
    if (mapper[item]) {
      headerArr = [...headerArr, mapper[item]];
    }
  });
  const modifiedHeaderArr = Object.values(DATA_MAPPER).map(item =>
    headerArr.find(e => e === item),
  );
  return modifiedHeaderArr;
}
